import "./App.css";
import "./asessts/style/style.css";
import "./asessts/style/responsive.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Login from "./pages/auth/Login";
import VerifyOtp from "./pages/auth/VerifyOtp";
import Setting from "./pages/setting/Setting";
import Dashboard from "./pages/dashboard/Dashboard";
import { Toaster } from "react-hot-toast";
import Facility from "./pages/facilities/Facility";
import FacilityHospitalDetail from "./pages/facilities/FacilityHospitalDetail";
import FacilityPharmacyDetail from "./pages/facilities/FacilityPharmacyDetail";
import FacilityLabDetail from "./pages/facilities/FacilityLabDetail";
import FacilityFitnessDetail from "./pages/facilities/FacilityFitnessDetail";
import Professional from "./pages/professionals/Professional";
import Request from "./pages/request/Request";
import RequestDetail from "./pages/request/RequestDetail";
import PharmacyDetail from "./pages/request/PharmacyDetails";
import NurseDetail from "./pages/request/NuresDetail";
import Physico from "./pages/request/Physico";

import Services from "./services/Services";
import VerifyEmail from "./pages/auth/VerifyEmail";
import ResetPassword from "./pages/auth/ResetPassword";
import { ProtectedRoute, AuthRoute } from "./components/ProtectedRoute";
import MedicalLabScientistDetail from "./pages/request/MedicalLabScientistDetail";
import FitnessCenterDetail from "./pages/request/FitnessCenterDetail";
import HospClinicDetail from "./pages/request/HospClinicDetail";
import LaboratoryDetail from "./pages/request/LaboratoryDetail";
import NotFound from "./pages/NotFound";
import ProfessionalDetailsPage from "./pages/professionals/ProfessionalDetailsPage";
function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          {/* Auth Routes - only accessible when not logged in/verified */}
          <Route
            path="/"
            element={
              <AuthRoute>
                <Login />
              </AuthRoute>
            }
          />
          <Route
            path="/verify-otp"
            element={
              <AuthRoute>
                <VerifyOtp />
              </AuthRoute>
            }
          />
          <Route
            path="/forgot-password"
            element={
              <AuthRoute>
                <VerifyEmail />
              </AuthRoute>
            }
          />
          <Route
            path="/change-password"
            element={
              <AuthRoute>
                <ResetPassword />
              </AuthRoute>
            }
          />
          {/* <Route path="/change-password" element={<ResetPassword />} /> */}
          {/* Protected Routes - only accessible when logged in and verified */}
          <Route
            path="/setting"
            element={
              <ProtectedRoute>
                <Setting />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/facilities"
            element={
              <ProtectedRoute>
                <Facility />
              </ProtectedRoute>
            }
          />
          <Route
            path="/professional"
            element={
              <ProtectedRoute>
                <Professional />
              </ProtectedRoute>
            }
          />
          <Route
            path="/request"
            element={
              <ProtectedRoute>
                <Request />
              </ProtectedRoute>
            }
          />
          <Route
            path="/services"
            element={
              <ProtectedRoute>
                <Services />
              </ProtectedRoute>
            }
          />
          <Route
            path="/request-detail-doctor/:id"
            element={
              <ProtectedRoute>
                <RequestDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/request-detail-pharmacy/:id"
            element={
              <ProtectedRoute>
                <PharmacyDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/request-detail-nurse/:id"
            element={
              <ProtectedRoute>
                <NurseDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/request-detail-physiotherapist/:id"
            element={
              <ProtectedRoute>
                <Physico />
              </ProtectedRoute>
            }
          />
          <Route
            path="/request-detail-medicalLabScientist/:id"
            element={
              <ProtectedRoute>
                <MedicalLabScientistDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/request-detail-fitnessCenter/:id"
            element={
              <ProtectedRoute>
                <FitnessCenterDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/request-detail-hospClinic/:id"
            element={
              <ProtectedRoute>
                <HospClinicDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/request-detail-laboratory/:id"
            element={
              <ProtectedRoute>
                <LaboratoryDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/facilities-detail-hospital/:id"
            element={
              <ProtectedRoute>
                <FacilityHospitalDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/facilities-detail-Pharmacy/:id"
            element={
              <ProtectedRoute>
                <FacilityPharmacyDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/facilities-detail-Lab/:id"
            element={
              <ProtectedRoute>
                <FacilityLabDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/facilities-detail-Fitness/:id"
            element={
              <ProtectedRoute>
                <FacilityFitnessDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/professional-detail-doctor/:id"
            element={
              <ProtectedRoute>
                <ProfessionalDetailsPage apiType="doctor" label="Doctor" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/professional-detail-nurse/:id"
            element={
              <ProtectedRoute>
                <ProfessionalDetailsPage apiType="nurse" label="Nurse" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/professional-detail-physiotherapist/:id"
            element={
              <ProtectedRoute>
                <ProfessionalDetailsPage
                  apiType="physiotherapist"
                  label="Physiotherapist"
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/professional-detail-scientist/:id"
            element={
              <ProtectedRoute>
                <ProfessionalDetailsPage
                  apiType="medicalLabScientist"
                  label="Scientist"
                />
              </ProtectedRoute>
            }
          />
          {/* Catch-all route for 404 Not Found */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Toaster reverseOrder={true} />
    </div>
  );
}

export default App;
